<template>
    <div ref="clock" class="clock">
    </div>
</template>

<script>

    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";
    import am4themes_animated from "@amcharts/amcharts4/themes/animated";
    import themeDark from "@amcharts/amcharts4/themes/dark";

    am4core.useTheme(themeDark);
    am4core.useTheme(am4themes_animated);

    export default {

        data() {
            return {
                hourHand: null,
                minutedHand: null,
                secondsHand: null,
                wisdoms: [
                    'It may be that time',
                    'Time is money',
                    'Time waits for no one',
                    'Lost time is never found again',
                    'Punctuality is the thief of time',
                    'Time is an illusion'
                ]
            }
        },

        methods: {
            updateHands() {
                // get current date
                let date = new Date();
                let hours = date.getHours();
                let minutes = date.getMinutes();
                let seconds = date.getSeconds();

                // set hours
                this.hourHand.showValue(hours + minutes / 60, 0);
                // set minutes
                this.minutesHand.showValue(12 * (minutes + seconds / 60) / 60, 0);
                // set seconds
                this.secondsHand.showValue(12 * date.getSeconds() / 60, 300);
            },

            drawClock() {
                // create chart
                let chart = am4core.create(this.$refs.clock, am4charts.GaugeChart);
                chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

                chart.startAngle = -90;
                chart.endAngle = 270;
                chart.paddingTop = 0;
                chart.marginTop = 0;

                let axis = chart.xAxes.push(new am4charts.ValueAxis());
                axis.min = 0;
                axis.max = 12;
                axis.strictMinMax = true;

                axis.renderer.line.strokeWidth = 8;
                axis.renderer.line.strokeOpacity = 1;
                axis.renderer.minLabelPosition = 0.05; // hides 0 label
                axis.renderer.inside = true;
                axis.renderer.labels.template.radius = 35;
                axis.renderer.axisFills.template.disabled = true;
                axis.renderer.grid.template.disabled = true;
                axis.renderer.ticks.template.length = 12;
                axis.renderer.ticks.template.strokeOpacity = 1;
                axis.renderer.labels.template.fill = am4core.color("#ddd");

                let range = axis.axisRanges.create();
                range.startValue = 0;
                range.endValue = 12;
                range.grid.visible = false;
                range.tick.visible = true;
                range.label.visible = false;

                // Clock face
                let axisFill = range.axisFill;
                axisFill.fillOpacity = 1;
                axisFill.disabled = false;
                axisFill.fill = am4core.color("#666");

                this.hourHand = chart.hands.push(new am4charts.ClockHand());
                this.hourHand.radius = am4core.percent(60);
                this.hourHand.startWidth = 10;
                this.hourHand.endWidth = 10;
                this.hourHand.rotationDirection = "clockWise";
                this.hourHand.pin.radius = 10;
                this.hourHand.zIndex = 0;

                this.minutesHand = chart.hands.push(new am4charts.ClockHand());
                this.minutesHand.rotationDirection = "clockWise";
                this.minutesHand.startWidth = 7;
                this.minutesHand.endWidth = 7;
                this.minutesHand.radius = am4core.percent(70);
                this.minutesHand.zIndex = 1;

                this.secondsHand = chart.hands.push(new am4charts.ClockHand());
                this.secondsHand.fill = am4core.color("#DD0000");
                this.secondsHand.stroke = am4core.color("#DD0000");
                this.secondsHand.radius = am4core.percent(80);
                this.secondsHand.rotationDirection = "clockWise";
                this.secondsHand.zIndex = 2;
                this.secondsHand.startWidth = 1;

                this.updateHands();

                setInterval(() => {
                    this.updateHands();
                }, 1000);
            },
        },

        mounted() {
            this.drawClock();
        },

        created() {
            const index = Math.floor(Math.random() * this.wisdoms.length);
            this.$emit('settings', {title: 'Clock', info: this.wisdoms[index], configs: []});
            this.$emit('hide-title', true);
        }
    }

</script>

<style scoped>
    .clock {
        height: 350px;
    }
    </style>